export const UNIT_TYPES = ['#', 'Apt', 'Bldg', 'Fl', 'Rm', 'Room', 'Ste', 'Unit'];
